// Currency Exchanges Getters

export const getCurrencyExchangesList = state => {
  return state.currencyExchangesList
}

export const getCurrencyExchangeInfo = state => {
  return state.currencyExchangeInfo
}
